<div class="pb" [class.pb--compact]="compact()">

  <!-- Constraint Palette (always visible) -->
  <app-constraint-palette
    [disabledTypes]="usedTypes()"
    [allowedRole]="role()"
    (typeSelected)="addConstraint($event)" />

  <!-- Canvas: Constraint Chips -->
  <div class="pb-canvas" [class.pb-canvas--empty]="isEmpty()">
    @if (isEmpty()) {
      <div class="pb-empty">
        <mat-icon class="pb-empty-icon">shield</mat-icon>
        <p class="pb-empty-text">{{ 'policyBuilder.emptyState' | transloco }}</p>
      </div>
    } @else {
      <div class="pb-chips">
        @for (entry of entries(); track entry.trackId; let last = $last) {
          <app-constraint-chip
            #chipRef
            [constraint]="entry.constraint"
            [configured]="isConfigured(entry.constraint)"
            [static]="isStatic(entry.constraint)"
            [locked]="isLocked(entry.constraint)"
            [active]="isEditing(entry.trackId)"
            (edit)="onChipEdit(entry, $event)"
            (remove)="removeConstraint(entry.trackId)"
            [attr.data-track-id]="entry.trackId" />

          <!-- Register chip reference after render -->
          {{ registerChip(entry.trackId, chipRef) ?? '' }}

          @if (!last) {
            <span class="pb-and-connector">{{ 'policyBuilder.andConnector' | transloco }}</span>
          }
        }
      </div>
    }
  </div>

  <!-- Shared Popover Overlay -->
  @if (overlayOrigin(); as origin) {
    <ng-template cdkConnectedOverlay
                 [cdkConnectedOverlayOrigin]="origin"
                 [cdkConnectedOverlayOpen]="overlayOpen()"
                 [cdkConnectedOverlayPositions]="overlayPositions"
                 [cdkConnectedOverlayHasBackdrop]="true"
                 cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
                 cdkConnectedOverlayPanelClass="compact-popover-panel"
                 (backdropClick)="closePopover()"
                 (detach)="closePopover()">
      @if (editingEntry(); as entry) {
        <app-constraint-popover
          [constraint]="entry.constraint"
          (constraintChange)="onPopoverApply($event)"
          (closePopover)="closePopover()" />
      }
    </ng-template>
  }
</div>
